import React, {
	Component
} from 'react';
import { connect } from 'react-redux';
import { Layout, Button, Alert, Input, Tag, Row, Col, Spin, Badge, Icon, Pagination, message, Select, Affix, BackTop ,Modal, Radio} from 'antd';
import AllowTabs from '../allow_tabs/AllowTabs';
import axios from 'axios'
import WEB_API from '@/API/api';
import * as action from './action'
import { ASSIST, PAPER, ASSISTKNOW, KNOWLEDGEWITHISSUE, QUESTIONFILTER, ALBUM } from '@/utils/questionManageType';
import '../style.less'

import * as Types from '@/utils/questionType'
import { view as EditDelQuestionManage } from './editDelQuestionManage'

import Question from '@/entry_question_editor/question/question_view/view';

import { PropTypes } from 'prop-types';
import CopyText from './CopyText'
const {
	Header,
	Footer,
	Sider,
	Content
} = Layout;
const confirm = Modal.confirm;

const Search = Input.Search;
const Option = Select.Option;

class LookOverQuestion extends Component {

	static contextTypes = {
		router: PropTypes.object.isRequired
	};
	state = {
		collapsed: false, //侧边栏隐藏
		assist_id: '-1',
		knowList: [],
		well_chosen: [],
		well_chosen_id: -1,
		order: [],
		order_type: [],
		order_type_id: 'asc', // desc，默认修改为asc(升序)
		order_id: '-1',
		difficulty: '-1',
		search: "",
		search_words:'',
		system_type: ['-1'], //全部
		display_type: ['0'], //全部
		hot: -1,
		right_rate: "",
		online_status: -1,
		know_id: -1,
		section_id: -1,
		paper_id: "",
		question_pack_id: '',
		relate_id: "",
		questionListType: ASSIST,
		type: ASSIST,
		selectedQuestionId: [],
		page: 1,
		pagesize: localStorage.getItem('questionlist_pagesize') || 10,
		isGetQuestionListFetching: false,
		isGetAssistQuestionFilterListFetching: false,
		isGetTreeListFetching: false,
		isGetTypeListFetching: false,
		assistQuestionKnowList: {},

		defaultAssistList: [],
		typeList: {},
		treeList: {},
		assistList: {},
		assistQuestionFilterList: {},
		error: '',
		search_type: '1',
		searchPosition: '0'
	}
	componentDidMount() {
		this.initData()
		let queryStr=this.props.location.search
		if(queryStr.length&&queryStr.includes('cateitem')){
			let search_words=queryStr.split('=')[1]
			this.setState({search_words},()=>{
				this.handleSearch()
			})
		}
	}
	initData(){
		//教辅版本选中数据
		const {defaultAssistList} = this.state,
			  {typeList,assistList,treeList,selectedKeys}=this.props

		this.getTypeList(() => this.getNoSubjectAssistList());
		
		if(defaultAssistList.length > 2) {
			let assist_id=defaultAssistList[defaultAssistList.length - 1]
			this.setState({assist_id});
		}
		
		typeList.source?this.setState({typeList:typeList}):null
		assistList?this.setState({assistList}):null
		treeList?this.setState({treeList}):null
		//选中章节时更新题目
		selectedKeys?this.handleGetQuestionList():null

		if(this.props.defaultAssistList && this.props.defaultAssistList.length) {
			const {defaultAssistList} = this.props;
			// 7.2 版本修改-bug:根据教辅展示树列表
			const {type} = this.state;

			let rootId = defaultAssistList[defaultAssistList.length - 1];
			this.getTreeList({
				type,
				rootId
			});
			// 7.2 结束
			this.setState({
				defaultAssistList,
				assist_id: rootId
			});
			//...不好的赋值
			this.state.defaultAssistList = defaultAssistList;
			this.state.assist_id = rootId;

		}else {
			this.setState({
				defaultAssistList: []
			})
		}
	}

	onCollapse = () => {
		this.setState({
			collapsed:!this.state.collapsed
		});
	}
	/*获得tab的list*/
	getTypeList = (callback) => {
		this.setState({
			isGetTypeListFetching: true
		})
		axios.post(WEB_API.GET_TYPE_LIST, {}).then((res) => {
			res = res.data
			if(res.code === 0) {
				this.setState({
					typeList: res.data,
					isGetTypeListFetching: false
				});
				setTimeout(() => {
					this.props.setTypeList(this.state.typeList)
				}, 0)
				callback()
			} else {
				this.setState({
					error: res.message
				})
			}
		}, (error) => {
			message.error('网络错误！');
		});
	}
	/*获得教材列表*/
	getNoSubjectAssistList = () => {
		axios.post(WEB_API.GET_NO_SUBJECT_ASSIST_LIST, {}).then((res) => {
			res = res.data
			if(res.code === 0) {
				this.setState({
					assistList: res.data
				});
				setTimeout(() => {
					this.props.setAssistList(this.state.assistList)
				}, 0)

			} else {
				message.error(res.message);
			}
		}, (error) => {
			message.error('网络错误！');
		});
	}
	/*级联选择器选择教材*/
	handleAssistChange = (value, selectedOptions) => {
		this.props.setQuestionList(Object.assign({}, this.props.questionList, {
			list: []
		}))
		let {
			assist_id
		} = this.state;
		if(value.length === 3) {
			this.setState({
				defaultAssistList: value
			});
			if(assist_id == value[value.length - 1]) return;
			setTimeout(() => {
				this.props.setDefaultAssistList(this.state.defaultAssistList)
			}, 0)

			assist_id = value[value.length - 1];
			this.setState({
				assist_id
			});
			this.handleGetTreeList(ASSIST, value[value.length - 1]);
		}
	}
	/*获得章节的信息*/
	handleGetTreeList = (type, rootId) => {
		if(type == PAPER) return this.getTreeList({
			type,
			rootId: 0,
			page: 1,
			pagesize: this.state.pagesize
		});
		this.getTreeList({
			type,
			rootId: type == ASSIST ? rootId : 0
		});

	}
	/*获得树*/
	getTreeList = (data) => {
		axios.post(WEB_API.GET_TREE_LIST, data).then((res) => {
			res = res.data
			if(res.code === 0) {
				this.setState({
					treeList: Object.assign(this.state.treeList, {
						[res.data.type]: res.data
					})
				});
				setTimeout(() => {
					this.props.setTreeList(this.state.treeList)
				}, 0)

			} else {
				message.error(res.message);
			}
		}, (error) => {
			message.error('网络错误！');
		});
	}
	/*章节下的筛选条件列表接口*/
	getAssistQuestionFilterList = (data, callback) => {
		this.setState({
			isGetAssistQuestionFilterListFetching: true
		})
		axios.post(WEB_API.ASSIT_QUESTION_FILTER, data).then((res) => {
			res = res.data
			if(res.code === 0) {
				this.setState({
					assistQuestionFilterList: res.data,
					isGetAssistQuestionFilterListFetching: false
				});
				callback && callback()
			} else {
				message.error(res.message);
				this.setState({
					isGetAssistQuestionFilterListFetching: false
				})
			}
		}, (error) => {
			message.error('网络错误！');
		});
	}
	/*选择了章节树的节点*/
	handleTreeSelect = (selectedKeys, type) => {
		this.props.setQuestionList(Object.assign({}, this.props.questionList, {
			list: []
		}))
		const {
			difficulty,
			system_type,
			display_type
		} = this.state;
		this.props.setSelectedKeys(selectedKeys)
		if(selectedKeys.length == 0) {
			return
		}
		this.setState({
			questionListType: type
		});

		switch(type) {
			case ASSIST:
				const {
					assist_id
				} = this.state;
				this.getAssistQuestionFilterList({
					assist_id,
					section_id: selectedKeys[0]
				}, () => {
					const {
						assistQuestionFilterList
					} = this.state;
					let {
						well_chosen,
						order,
						order_type
					} = assistQuestionFilterList
					this.setState({
						knowList: assistQuestionFilterList.knowledge_list,
						order,
						order_type,
						well_chosen
					});
				});
				this.setState({
					difficulty,
					show_type: -1,
					system_type,
					display_type,
					hot: -1,
					right_rate: "",
					online_status: -1,
					knowList: [],
					well_chosen: [],
					order: [],
					assist_id,
					section_id: selectedKeys[0],
					know_id: -1,
					issue_id: "",
					paper_id: "",
					question_pack_id: ''
				});
				break;
			case PAPER:
				this.setState({
					difficulty,
					show_type: -1,
					system_type,
					display_type,
					hot: -1,
					right_rate: "",
					online_status: -1,
					knowList: [],
					well_chosen: [],
					order: [],
					section_id: '',
					know_id: -1,
					paper_id: selectedKeys[0],
					issue_id: "",
					question_pack_id: ''
				});
				break;
			case KNOWLEDGEWITHISSUE:
				this.setState({
					difficulty,
					show_type: -1,
					system_type,
					display_type,
					hot: -1,
					right_rate: "",
					online_status: -1,
					knowList: [],
					well_chosen: [],
					order: [],
					section_id: '',
					know_id: selectedKeys[0],
					issue_id: "",
					paper_id: "",
					question_pack_id: ''
				});
				break;
			case ALBUM:
				this.setState({
					difficulty,
					show_type: -1,
					system_type,
					display_type,
					hot: -1,
					right_rate: "",
					online_status: -1,
					knowList: [],
					well_chosen: [],
					order: [],
					section_id: '',
					know_id: -1,
					issue_id: "",
					paper_id: "",
					question_pack_id: selectedKeys[0],
				});
				break;
			default:
				// statements_def
				break;
		}
		this.setState({
			relate_id: selectedKeys[0],
			type
		});
		this.handleGetQuestionList();
	}

	handleGetQuestionList = (page = 1, pagesize = this.state.pagesize) => {

		this.setState({
			page
		})
		setTimeout(() => {
			const {
				well_chosen_id,
				order_type_id,
				order_id,
				difficulty,
				show_type,
				search,
				search_words,
				system_type,
				display_type,
				hot,
				right_rate,
				online_status,
				questionListType,
				know_id,
				assist_id,
				issue_id,
				paper_id,
				search_type,
				question_pack_id,
				type,
				searchPosition
			} = this.state;
			let section_id = this.props.selectedKeys ? this.props.selectedKeys[0] || -1 : -1;
			switch(+questionListType) {
				case ASSIST:
					this.getAssistQuestionList({
						well_chosen: well_chosen_id,
						order_type: order_type_id,
						order: order_id,
						difficulty,
						show_type,
						search,
						search_words,
						system_type,
						display_type,
						hot,
						right_rate,
						online_status,
						page,
						pagesize,
						section_id,
						assist_id,
						search_type,
						type,
						searchPosition
					});
					break;
				case PAPER:
					this.getAssistQuestionList({
						paper_id,
						difficulty,
						show_type,
						search,
						search_words,
						system_type,
						display_type,
						hot,
						right_rate,
						online_status,
						page,
						pagesize,
						search_type,
						type
					});
					break;
				case KNOWLEDGEWITHISSUE:
					this.getAssistQuestionList({
						know_id,
						difficulty,
						show_type,
						search,
						search_words,
						system_type,
						display_type,
						hot,
						right_rate,
						online_status,
						page,
						pagesize,
						search_type,
						type
					});
					break;
				case ASSISTKNOW:
					this.getAssistQuestionList({
						well_chosen: well_chosen_id,
						order_type: order_type_id,
						order: order_id,
						difficulty,
						show_type,
						search,
						search_words,
						system_type,
						display_type,
						hot,
						right_rate,
						online_status,
						page,
						pagesize,
						section_id,
						assist_id,
						know_id,
						search_type,
						type
					});
					break;

				case ALBUM:
					this.getAssistQuestionList({
						question_pack_id,
						difficulty,
						show_type,
						search,
						search_words,
						system_type,
						display_type,
						hot,
						right_rate,
						online_status,
						page,
						pagesize,
						search_type,
						type
					});
					break;
				default:
					break;
			}
		}, 0);
	}
	/*获取题目列表*/
	getAssistQuestionList = (data, callback) => {
		let index = data.system_type.findIndex(d => d == '选中多个')
		if(index !== -1) {
			data.system_type.splice(index, 1)
		}
		let index1 = data.display_type.findIndex(d => d == '选中多个')
		if(index1 !== -1) {
			data.display_type.splice(index1, 1)
		}
		data = JSON.parse(JSON.stringify(data))
		this.setState({
			isGetQuestionListFetching: true
		})
		this.props.setQuestionList(Object.assign(this.props.questionList, {
			list: []
		}))
		axios.post(WEB_API.GET_QUESTION_LIST, data).then((res) => {
			res = res.data
			if(res.code === 0) {
				this.props.setQuestionList(res.data)
				this.setState({
					isGetQuestionListFetching: false
				});
				callback && callback()
			} else {
				message.error(res.message);
				this.setState({
					isGetQuestionListFetching: false
				})
			}
		}, (error) => {
			message.error('网络错误！');
		});
	}

	pageChange = (page, pagesize) => {
		this.setState({
			page,
			pagesize
		});
		this.handleGetQuestionList(page, pagesize);
		document.querySelector('.questionListScroll').scrollTop = 0
	}

	pagesizeChange = (page, pagesize) => {
		this.setState({
			page,
			pagesize
		});
		localStorage.setItem('questionlist_pagesize', pagesize)
		this.handleGetQuestionList(page, pagesize);
	}

	handleTableChange = key => {
		if(key != ASSIST) {
			this.handleGetTreeList(key);
		}
		this.props.setQuestionList({
			list: []
		});
		this.props.setSelectedKeys([]);
		this.setState({
			questionListType: key
		});
	}

	getPaperTreeList = (page, pagesize) => {
		this.getTreeList({
			page,
			pagesize,
			type: PAPER,
			rootId: 0
		});
	}

	handleSearch = () => {
		if(!(this.props.selectedKeys && this.props.selectedKeys[0])) {
			this.setState({
				assistQuestionFilterList: {},
				isGetAssistQuestionFilterListFetching: false
			});
		}

		this.handleGetQuestionList(1, this.state.pagesize);
	}
	handleSearchChange = e => {
		const {
			value
		} = e.target;
		this.setState({
			search: value
		});
	}
	handleSearchWordsChange = e => {
		this.setState({
			search_words: e.target.value
		});
	}
	onSearchChange = value => {
		this.setState({
			search: value
		});
	}
	questionTypeChange = (value, type, option, list) => {
		if(value.findIndex) {
			let index = value.findIndex && value.findIndex(d => d == '选中多个')
			if(index !== -1) {
				value.splice(index, 1)
			}
		}
		switch(type) {
			case "questiontype":
				this.setState({
					show_type: value
				});
				this.handleGetQuestionList()
				break;
			case "systemtype":
				if(value.length < this.state.system_type.length) { //减少选中时
					if(value.length == list.length - 1) { //取消全部时
						let index = value.findIndex(d => d == '-1')
						if(index == -1) {
							value = []
						}
					}
					let index = value.findIndex(d => d == '-1')
					if(index !== -1) {
						value.splice(index, 1)
					}
				} else if(value.length == list.length - 1) { //选中了其余所有后自动选中全部
					value = list.map(d => '' + d.id)
				}
				this.setState({
					system_type: value
				});
				break;
			case "displaytypelist":
				if(value.length < this.state.display_type.length) { //减少选中时
					if(value.length == list.length - 1) { //取消全部时
						let index = value.findIndex(d => d == '0')
						if(index == -1) {
							value = []
						}
					}
					let index = value.findIndex(d => d == '0')
					if(index !== -1) {
						value.splice(index, 1)
					}
				} else if(value.length == list.length - 1) { //选中了其余所有后自动选中全部
					value = list.map(d => '' + d.id)
				}
				this.setState({
					display_type: value
				});
				this.handleGetQuestionList()
				break;
			case "difficult":
				this.setState({
					difficulty: value
				});
				this.handleGetQuestionList()
				break;
		}

	}
	tagClick = (id, type) => {
		let {
			order_type_id,
			order_id,
			well_chosen_id,
			know_id
		} = this.state
		if(type == 'knowList') {
			if(id === know_id) {
				know_id = -1
			} else {
				know_id = id
			}
			this.setState({
				questionListType: ASSISTKNOW,
				know_id,
			});
		}
		if(type == 'well_chosen') {
			if(id === well_chosen_id) {
				well_chosen_id = -1
			} else {
				well_chosen_id = id
			}
			this.setState({
				questionListType: ASSISTKNOW,
				well_chosen_id,
			});
		}
		if(type == 'order') {
			if(id === order_id) {
				if(order_type_id === "asc") {
					order_type_id = 'desc'
				} else {
					order_type_id = 'asc'
				}
			} else {
				order_type_id === "asc"
			}
			this.setState({
				questionListType: ASSISTKNOW,
				order_type_id,
				order_id: id,
			});
		}
		this.handleGetQuestionList();

	}
	showSelectedQuestion = () => { //跳转到购物车
		const {
			shopcar
		} = this.props;
		if(!this.props.role_qshow.toShopping || !shopcar.length) return; //没有购物车权限或没选题
		setTimeout(() => {
			this.context.router.history.push(`lookoverquestion/questioncar`);
		}, 0)

	}
	addToCart = (id, well_chosen) => { //加入已选
		let {
			shopcar
		} = this.props;
		shopcar = [...shopcar];

		if(shopcar.some(d => d.question_id == id)) {
			shopcar.splice(shopcar.findIndex(d => d.question_id == id), 1)
		} else {
			shopcar.push({
				question_id: id,
				well_chosen,
				relate_id: this.state.relate_id
			});
		}
		this.props.setShopcar(shopcar);
	}
	allToCart = type => {
		let {
			shopcar,
			questionList
		} = this.props;
		shopcar = [...shopcar]
		if(type === "empty") {
			this.props.setShopcar([]);
		} else if(type === "pack") {
			let itemList = questionList.list.map(val => {
				return {
					question_id: val.question_id,
					well_chosen: val.well_chosen,
					relate_id: this.state.relate_id
				}
			});
			itemList.forEach(val => {
				if(!shopcar.some(d => d.question_id === val.question_id)) shopcar.push(val);
			});
			this.props.setShopcar(shopcar);
		}
	}
	//批量上线关联关系
	batchOnlineRelation=()=>{
		const _this=this
		confirm({
            title: '提示',
            content: '此操作将上线当前章节全部题目关联关系，确定批量上线吗？',
            onOk() {
				axios.post(WEB_API.BATCH_ONLINE_RELATION, {section_id:_this.state.section_id,question_id:0}).then((res)=>{
					res = res.data;
					if (res.code === 0) {
						message.success("批量上线关联关系成功！");
						_this.refreshQuestionList();
					}else{
						message.error(res.message);
					}
				},()=>{message.error("操作失败！")})
            },
            onCancel() {},
        });
	}
	refreshQuestionList = () => {
		this.handleGetQuestionList(this.state.page, this.state.pagesize);
	}
	changeListNoRefreshQuestionList = (id) => {
		let questionList = this.props.questionList;
		let index = questionList.list.findIndex(d => d.question_id === id)
		if(!!index || +index === 0) {
			questionList.list.splice(index, 1)
		}
		this.props.setQuestionList(questionList)
		setTimeout(() => {
			this.forceUpdate()
		}, 0)
	}
	editQuestion = () => {
		this.context.router.history.push(`lookoverquestion/questioncar`);
	}

	checkMultiple = (type, list) => {
		if(type === 'systemtype') {
			let index = this.state.system_type.findIndex(d => d == '选中多个') //增加选中多个的效果
			if(index !== -1) {
				this.state.system_type.splice(index, 1)
			}

			if(this.state.system_type.some(d => d == '-1')) {

				let arr = list.map(d => '' + d.id)
				let index = arr.findIndex(d => d == '-1')
				if(index !== -1) {
					arr.splice(index, 1)
					arr.unshift('-1')
				}
				this.state.system_type = arr
			} else if(this.state.system_type.length > 1) {

				this.state.system_type.unshift('选中多个')
			}
		}
		if(type === 'displaytypelist') {

			let index = this.state.display_type.findIndex(d => d == '选中多个') //增加选中多个的效果
			if(index !== -1) {
				this.state.display_type.splice(index, 1)
			}
			if(this.state.display_type.some(d => d == '0')) {
				let arr = list.map(d => '' + d.id)
				let index = arr.findIndex(d => d == '0')
				if(index !== -1) {
					arr.splice(index, 1)
					arr.unshift('0')
				}
				this.state.display_type = arr
			} else if(this.state.display_type.length > 1) {

				this.state.display_type.unshift('选中多个')
			}
		}
	}
	setDefaultAssistList = (data) => {
		this.props.setDefaultAssistList(data);
		this.setState({
			defaultAssistList: data
		});
		this.handleAssistChange(data);
	}
	gotoRecord=()=>{
		this.context.router.history.push(`lookoverquestion/questionRecord`);
	}

	gotoAddQuestion=()=>{
		console.log('type',this.state.type);
		console.log('questionListType',this.state.questionListType);
		console.log('selectedKeys',this.props.selectedKeys);
		if(this.state.questionListType != ASSIST){
			message.error('只允许在章节下添加题目');
		}
		if(!this.props.selectedKeys || !this.props.selectedKeys[0]){
			message.error('请选择章节');
		}
		window.open(window.location.origin + `/question.html#/questionmanageadd-101-${this.props.selectedKeys[0]}/fillin/`)
	}
	
	
	render() {
		const {
			collapsed,
			isGetQuestionListFetching,
			isGetAssistQuestionFilterListFetching,
			isGetTreeListFetching,
			isGetTypeListFetching,
			search,
			search_words,
			page,
			pagesize,
			typeList,
			assistList,
			treeList,
			knowList,
			know_id,
			well_chosen,
			well_chosen_id,
			defaultAssistList,
			order,
			order_id,
			order_type_id,
			error,
			type,
			section_id,
			searchPosition
		} = this.state
		const {
			questionList,
			shopcar
		} = this.props
		const {
			total,
			list,
			difficult
		} = questionList;
		questionList.relate_systemtype_displaytype &&
			list.forEach((question) => { ///题目展示列表右侧的展示类型列表
				let arr = questionList.relate_systemtype_displaytype.filter(d1 => {
					return ~~question.type_show === ~~d1.show_type
				})
				let arr2 = questionList.displaytypelist.filter((d) => {
					return arr.some(d1 => d1.display_type === d.id)
				})
				question.displaytypelist = arr2
			});

		// 查看题目-是否是章节tab
		let chapterId = ''
		typeList.source && typeList.source.forEach((item) => {
			if(item.title === '章节') {
				chapterId = item.type;
			}
		});
		let isChapter = [chapterId, ASSISTKNOW].includes(this.state.questionListType)

		return(
			<div  id="summary_wrap" >
                {
                    !!error && <Alert style={{margin:'10px 0'}} message= { error } closable type="error" showIcon />
                }

                <div style={{position:'relative'}}>
                    {/*左侧章节树隐藏显示*/}
                    <div style={{position:'fixed',overflowY:'scroll',transform:'translate(-30px,300px)'}} onClick={this.onCollapse}>
                        <div style={{display:'block',height:'20px',width:'14px',background:'#f3f3f3',cursor:'pointer'}}>
                            {
                                collapsed
                                    ?
                                    <Icon type="right" />
                                    :
                                    <Icon type="left" />
                            }
                        </div>
                    </div>
                    <div style={{height: 'calc(100% - 80px)'}} className={`slideLeft my-nav-container ${collapsed?'close':'open'}`}>
                        {
                            !isGetTypeListFetching && typeList.source &&
                            <AllowTabs
                                size = "small"
                                data = { typeList.source }
                                handleTableChange = { this.handleTableChange }
                                handleAssistChange = { this.handleAssistChange }
                                handleTreeSelect = { this.handleTreeSelect }
                                setExpandedKeys={(expandedKeys)=>{this.props.setExpandedKeys(expandedKeys)}}
                                expandedKeys={this.props.expandedKeys}
                                selectedKeys={this.props.selectedKeys}
                                assistList = { assistList }
                                loading = { isGetTreeListFetching }
                                treeList = { treeList }
                                defaultAssistList = { defaultAssistList }
                                handleGetPaperTreeList = { this.getPaperTreeList }
                                setDefaultAssistList = {this.setDefaultAssistList}
                                onSearchChange={this.onSearchChange}
                            />
                        }
                    </div>
                    <BackTop visibilityHeight={100} ></BackTop>
                     <div  style={{position:'absolute',left:'250px',width:'calc(100% - 250px)'}} className={`${collapsed?'width100':''}`} >
                         <Layout style={{paddingLeft:'20px'}}>
                             <Header>
                                 <div>
									<div className="valueType">
										{/* <div className={`typeStyle ${searchPosition === '0'?'checkStyle':''}`} onClick={() => this.setState({searchPosition: '0'})}>按题目搜索</div>
										<div className={`typeStyle ${searchPosition === '1'?'checkStyle':''}`} onClick={() => this.setState({searchPosition: '1'})}>按答案搜索</div> */}
										<Radio.Group value={ searchPosition } onChange={(e) => { this.setState({searchPosition: e.target.value}) }}>
											<Radio.Button value="0">按题目搜索</Radio.Button>
											<Radio.Button value="1">按答案搜索</Radio.Button>
										</Radio.Group>

									</div>
									<Select value={this.state.search_type }
											style={{marginRight:20}}
											onChange = { (value, option) => this.setState({search_type: value}) }>

											<Option key = {1} value= {'1'}>精确搜索</Option>
											<Option key = {2} value= {'2'}>分词搜索</Option>

									</Select>

                                     <Search
                                        //  placeholder = "搜索题目..."
                                         placeholder = { `${this.state.search_type === '1' ? '精确' : '分词'}搜索${this.state.searchPosition === '0' ? '题目' : '答案'}...` }
                                         style = {{ width: 200 }}
                                         value = {search}
                                         onSearch= { this.handleSearch }
                                         size="large"
                                         onChange = { this.handleSearchChange }
                                     />
                                     {
                                     this.props.product=='7'&&
                                     <Search
                                        //  placeholder = "搜索字词..."
																				 placeholder = { `${this.state.search_type === '1' ? '精确' : '分词'}搜索${this.state.searchPosition === '0' ? '题目' : '答案'}...` }
                                         style = {{ width: 200,marginLeft:'15px' }}
                                         value = {search_words}
                                         onSearch= { this.handleSearch }
                                         size="large"
                                         onChange = { this.handleSearchWordsChange }
                                     />
                                     }

                                     <div style={{position:'fixed',top:'80px',right:'30px',zIndex:99}}>
                                         <Badge onClick={ this.showSelectedQuestion } count = { shopcar.length }>
                                             <div className="shopcar">
                                                 <Icon className="shopcaricon" type="shopping-cart" />
                                             </div>
                                         </Badge>
                                     </div>
                                 </div>
                                 {
                                     this.props.role_qshow.addManyShopping >0 && !this.props.productAi &&
                                     <CopyText
                                         copyValue = { shopcar.map(d=>d.question_id).join('\n') }
                                         text= "复制已选题目ID"
                                     />
                                 }
								 {
									 this.props.role_qshow.addManyShopping >0 && this.props.productAi &&
									 <CopyText
										 copyValue = { shopcar.map(d=>d.question_id).join(',\n') }
										 text= "复制已选题目ID（逗号）"
									 />
								 }


                                 { 
                                 this.props.role_qshow.delManyShopping&&
                                 <Button className="control_btn" type="primary" onClick= { () => this.allToCart("empty") }>清空已选题目</Button>
                                 }
                                 { 
                                 this.props.role_qshow.addManyShopping&&
                                 <Button className="control_btn" type="primary" onClick= {()=>this.allToCart("pack")}>批量添加购物车</Button>
                                 }
								 {section_id&&section_id!=-1&&<Button className="control_btn" type="primary" onClick= {this.batchOnlineRelation }>批量上线关联关系</Button>}
								<Button className="control_btn" type="danger" onClick= {this.gotoRecord}>题目日志</Button>
								
								 {
									 this.props.role_qshow.editQuestion >0 && this.props.productAi
									 && this.state.questionListType == ASSIST && this.props.selectedKeys && this.props.selectedKeys[0] &&
									 <Button className="control_btn" type="primary" onClick= {this.gotoAddQuestion}>在当前章节添加题目</Button>
								 }
                                     
                                 
                             </Header>
                             <Content>
                                 {
                                     difficult&&!!difficult.length &&
                                     QUESTIONFILTER.map((val,key)=>(
                                             questionList[val.type]&&questionList[val.type].length &&
                                             <div key = {key} style={{display:'inline-block',fontWeight:'500',margin:'10px 10px 10px 0'}} className={'look_over_question_filter'}>
                                            <span style={{marginRight:'10px'}}>
                                                {val.name}：
                                            </span>
                                                 {(val.type==='displaytypelist'||val.type==='systemtype')&&this.checkMultiple(val.type,questionList[val.type])}

                                                 <Select value={ val.type==='difficult'?''+this.state.difficulty:val.type==='systemtype'?this.state.system_type:val.type==='displaytypelist'?this.state.display_type:[]  }
                                                         style={(val.type==='systemtype'||val.type==='displaytypelist')?{width:100, marginRight:20}:{marginRight:20}}
                                                         key={ key }
                                                         mode={(val.type==='systemtype'||val.type==='displaytypelist')?"multiple":''}
                                                         onBlur={()=>this.handleGetQuestionList(1,pagesize)}
                                                         onChange = { (value, option) => this.questionTypeChange(value, val.type,option,questionList[val.type]) }>
                                                     {
                                                         questionList[val.type].map((v,k) =>
                                                             <Option key = {k} value= {''+v.id}>{v.name}</Option>
                                                         )
                                                     }
                                                 </Select>
                                             </div>

                                         )
                                     )
                                 }
                                 {
                                     !!knowList.length &&
                                     <Row style={{marginBottom:20}}>
                                         <Col span={2} style={{fontSize:"14px", fontWeight:"600"}}>
                                             知识点：
                                         </Col>
                                         <Col span={22} style={{maxHeight:150, overflow:"auto"}}>
                                             <Spin spinning={ isGetAssistQuestionFilterListFetching }>
                                                 {
                                                     knowList.map((v,k)=>
                                                         <Tag className={`${ know_id === v.know_id ? 'selected' : ''} ${  v.is_relate == 1 ? '': 'not_related' }`}
                                                              key = { k }
                                                              style={{marginBottom:10}}
                                                              color="cyan-inverse"
                                                              onClick={ () => this.tagClick(v.know_id,'knowList') }>
                                                             { v.name} ({v.count})
                                                         </Tag>
                                                     )
                                                 }
                                             </Spin>
                                         </Col>
                                     </Row>
                                 }

                                 {
                                     !!well_chosen.length &&
                                     <Row style={{marginBottom:20}}>
                                         <Col span={2} style={{fontSize:"14px", fontWeight:"600"}}>
                                             分类：
                                         </Col>
                                         <Col span={22} style={{maxHeight:150, overflow:"auto"}}>
                                             <Spin spinning={ isGetAssistQuestionFilterListFetching }>
                                                 {
                                                     well_chosen.map((v,k)=>
                                                         <Tag className={`${ well_chosen_id === v.id ? 'selected' : ''} `}
                                                              key = { k }
                                                              style={{marginBottom:10}} color="cyan-inverse"
                                                              onClick={ () => this.tagClick(v.id,'well_chosen') }>
                                                             { v.name } ({v.count})
                                                         </Tag>
                                                     )
                                                 }
                                             </Spin>
                                         </Col>
                                     </Row>
                                 }
                                 {
                                     !!order.length &&
                                     <Row style={{marginBottom:20}}>
                                         <Col span={2} style={{fontSize:"14px", fontWeight:"600"}}>
                                             排序：
                                         </Col>
                                         <Col span={22} style={{maxHeight:150, overflow:"auto"}}>
                                             <Spin spinning={ isGetAssistQuestionFilterListFetching }>
                                                 {
                                                     order.map((v,k)=>
                                                         <Tag  key = { k } className={`${ order_id === v.id ? 'selected' : ''} `} style={{marginBottom:10}} color="cyan-inverse" onClick={ () => this.tagClick(v.id,'order') }>
                                                             { v.name }
                                                             {
                                                                 order_id === v.id &&
                                                                 (
                                                                     order_type_id === 'asc' ?
                                                                         <Icon type="arrow-up"/>
                                                                         :
                                                                         <Icon type="arrow-down"/>
                                                                 )
                                                             }
                                                         </Tag>

                                                     )
                                                 }
                                             </Spin>
                                         </Col>
                                     </Row>
                                 }


                                 {
                                     <div className={'look-over-question'}>
                                         {
                                             this.state.isGetQuestionListFetching?
                                                 <div style={{fontSize: "16px", height: "30px", marginBottom: "50px"}}>
                                                     <p style={{paddingTop: 15, paddingLeft: 50, color: 'green'}}>加载中...</p>
                                                 </div>
                                                 :
                                             !!list.length ?
                                                 list.map((v, k) =>
                                                     <div key={v.question_id} style={{marginBottom: '30px',position:'relative'}}>

                                                         <div className={'question'}>
                                                             {/*返工原因展示*/}
                                                             {v.mark &&v.mark!==''&&
                                                             <div style={{textAlign:'center',fontSize:'15px',marginBottom:'15px'}}>
                                                                 <Tag color="#f50" style={{fontSize:14}}><span>返工原因：</span><span>{v.mark}</span></Tag>
                                                             </div>
                                                             }
                                                             <Question data={v} isChapter={isChapter} showRelative={true}  num={(page-1)*pagesize+k}/>

                                                         </div>
                                                         {/*题目管理页面的一些按钮 放到了题目框的外面*/}
                                                         {
                                                             Types.NUM_TO_TYPE[v.type_show]&&
                                                             <EditDelQuestionManage
                                                                 subject={this.props.user.subject}
                                                                 product={this.props.user.product}
                                                                 question={v}
                                                                 update={()=>{this.forceUpdate()}}
                                                                 parent={{
                                                                     shopcar,
                                                                     section_id:this.props.selectedKeys?this.props.selectedKeys[0]:-1,
                                                                     addToCart:this.addToCart,
                                                                     type,
                                                                     relate_id:this.props.selectedKeys?this.props.selectedKeys[0]:-1,
                                                                     refresh:this.refreshQuestionList,
                                                                     changeListNoRefresh:this.changeListNoRefreshQuestionList,//删除关联时修改列表不刷新页面
                                                                     role_qshow:this.props.role_qshow,
                                                                 }}
                                                             />
                                                         }
                                                     </div>
                                                 ) :
                                                 <div style={{fontSize: "16px", height: "30px", marginBottom: "50px"}}>
                                                     <p style={{paddingTop: 15, paddingLeft: 50, color: 'green'}}>暂无题目</p>
                                                 </div>
                                         }
                                     </div>

                                 }

                             </Content>
                             <Footer style={{textAlign:'right'}}>
                                 {
                                     !!list.length &&
                                     <Pagination
									 	 pageSizeOptions={[10,20,30,50,100,200].map(d=>''+d)}
                                         showQuickJumper
                                         showSizeChanger
                                         total={+total}
                                         onChange={ this.pageChange }
                                         pageSize={+this.state.pagesize}
                                         onShowSizeChange = { this.pagesizeChange }
                                         current={page?(+page):1}
                                     />
                                 }

                             </Footer>
                         </Layout>
                     </div>


                </div>

            </div>
		)
	}
}

function mapState(state) {
	const {
		questionList,
		shopcar,
		typeList,
		assistList,
		treeList,
		expandedKeys,
		defaultAssistList,
		selectedKeys
	} = state.questionManage.lookOverQuestion, {
		role_qadmin
	} = state.user
	return {
		questionList,
		shopcar,
		role_qshow: role_qadmin ? role_qadmin.role_qshow : false,
		typeList,
		assistList,
		treeList,
		expandedKeys,
		defaultAssistList,
		selectedKeys,
		user: state.user,
		product:state.user.product,
		productAi:[4,8,9,11].indexOf(state.user.product) != -1
	};
}

function mapDispatch(dispatch) {
	return {
		setQuestionList: (data) => {
			dispatch(action.setQuestionList(data))
		},
		setShopcar: (data) => {
			dispatch(action.setShopcar(data))
		},
		setTypeList: (data) => {
			dispatch(action.setTypeList(data))
		},
		setAssistList: (data) => {
			dispatch(action.setAssistList(data))
		},
		setTreeList: (data) => {
			dispatch(action.setTreeList(data))
		},
		setExpandedKeys: (data) => {
			dispatch(action.setExpandedKeys(data))
		},
		setDefaultAssistList: (data) => {
			dispatch(action.setDefaultAssistList(data))
		},
		setSelectedKeys: (data) => {
			dispatch(action.setSelectedKeys(data))
		},

	}
}
export default connect(mapState, mapDispatch)(LookOverQuestion);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/view.js